import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import SubContact from './SubContact';
import { Helmet } from 'react-helmet';
import Gall from './Gall';

const gallery1 = [
    { src: `${require('../image/arv3.jpg')}` },
    { src: `${require('../image/arv9.jpg')}` },

    { src: `${require('../image/arv21.jpg')}` },
    { src: `${require('../image/arv23.jpg')}` },
    { src: `${require('../image/arv25.jpg')}` },
    { src: `${require('../image/gg1.jpg')}` },
    { src: `${require('../image/gg2.jpg')}` },


]


// const coreValue = [
//     {
//         title: "Integrity",
//         text: "We operate with honesty, transparency, and fairness in everything we do.",
//         img: `${require('../image/integrity.png')}`
//     }, {
//         title: "Excellence",
//         text: "We strive to exceed expectations through quality-driven processes and continuous improvement.",
//         img: `${require('../image/exellent.png')}`
//     },
//     {
//         title: "Innovation",
//         text: "We bring creative and practical solutions to complex challenges.",
//         img: `${require('../image/inovation.png')}`
//     },
//     {
//         title: "Collaboration",
//         text: "We work hand-in-hand with healthcare teams to co-create better outcomes.",
//         img: `${require('../image/collaboration.png')}`
//     },
//     {
//         title: "Commitment",
//         text: "We are deeply invested in our client’s success and healthcare transformation.",
//         img: `${require('../image/commitment.png')}`
//     }
// ]
const AboutUs = () => {
    useEffect(() => {
        AOS.init({ duration: 2000 });
    }, [])
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>About Us -  ARV Services & Consultant </title>
                <meta name="description" content="ARV Services & Consultant" />
                <meta name="keywords" content=" ARV Services & Consultant" />
            </Helmet>
            {/* <div style={{ height: '100vh', backgroundImage: `url(${require('../image/food3.png')})`, backgroundPosition: "center", backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
                <div class='d-flex align-items-center justify-content-center' style={{ width: '100%', height: '100%', background: 'rgba(0,0,0,0.6)' }}>
                    <p class='display-1 fw-bold text-white' data-aos="zoom-in">Abou<span class='text-success'>t</span> Us</p>
                </div>
            </div> */}
            <div class='d-flex align-items-center justify-content-center' style={{ height: '100vh' }}>
                <div>
                    <br />
                    <br /><br />
                    <div class='col-11 m-auto '>
                        <img style={{ width: '100%' }} src={require('../image/arvLogo.png')} data-aos="zoom-in" alt="" />
                    </div>
                </div>
            </div>


            <div class='col-11 m-auto'>
                <div class='col-11 m-auto'>
                </div>
            </div>
            {/* <div class='col-11 m-auto row align-items-center mt-3'>
                <div class='col-md-6'>
                    <div class='p-3'>
                        <img class='rounded-4' data-aos="zoom-in" src={require('../image/about.jpg')} style={{ width: '100%' }} alt="" />
                    </div>
                </div>
                <div class='col-md-6'>
                    <div class='col-sm-11 m-auto'>
                         <p class='fs-1 fw-bold'>ARV Services and Consultant</p> 
                         <p>ARV Services and Consultant is a company Which was established in May 2022, that provides various services, including:</p> 
                         <p class='fs-5 tjustify mt-2' data-aos="fade-up">We are trustworthy,,,,,, because In a company, trustworthiness is about reliability and dependability, ensuring employees and stakeholders can trust in the organization's actions and promises. It's built on a foundation of transparency, open communication, and fairness. Trustworthy companies foster a positive work environment that motivates employees, enhances teamwork, and contributes to overall success. </p> 

                        <p class='fs-5 tjustify ' data-aos="fade-up"><b>ARV Services & Consultant</b> is a professionally managed organization committed to delivering exceptional consultancy and auditing services tailored specifically for the Food Safety  sector. Founded by a team of highly qualified experts, ARV brings deep-rooted knowledge, industry best practices, and a client-focused approach to empower Retail, Manufacture units, Catering & Finence Sector . </p>
                        <p class='fs-5 tjustify mt-2' data-aos="fade-up">We specialize in a wide array of services including hospital planning, healthcare accreditation support, fire and electrical safety audits, healthcare staff training, and operational management consultancy. Our goal is to help healthcare institutions achieve clinical excellence, infrastructure compliance, operational efficiency, and quality certifications with ease and confidence. </p>
                        <p class='fs-5 tjustify mt-2' data-aos="fade-up"> With a growing presence and a robust portfolio of successfully delivered projects, ARV is on a mission to redefine healthcare consultancy across India and beyond. </p>
                    </div>
                </div>

            </div> */}
            <div class='col-11 m-auto mt-5 text-start'>
                <p class='fs-1 fw-bold'>ARV Services and Consultant</p>
                <p class='fs-5 '>ARV Services and Consultant is a company Which was established in May 2022, that provides various services, including:</p>
                <br />
                <div>
                    <p class='fs-3'>Services</p>
                    <ul>
                        <li><b> Training and Development: </b> Training programs to help individuals and businesses develop their skills and knowledge.</li>
                        <li><b>Consulting:</b> Consulting services to help businesses solve their challenges and achieve their goals</li>
                        <li><b>Financial Management:</b>  Financial management services to help businesses manage their financial resources.</li>
                        <li><b>Human Resource Management:</b> Human resource management services to help businesses manage their human resources.</li>
                    </ul>
                </div>
                <br />
                <div>
                    <p class='fs-3'>Features</p>
                    <ul>
                        <li><b>Experienced Team:</b> Our team consists of experienced professionals with expertise in various industries.</li>
                        <li><b>Customer-Centric Approach:</b>  We are committed to understanding our customers' needs and meeting their expectations.</li>
                        <li><b>Latest Technology:</b> We use the latest technologies and methodologies to provide high-quality services to our customers.</li>

                    </ul>
                </div>
                <br />
                <div>
                    <p class='fs-3'>Benefits</p>
                    <ul>
                        <li><b>Business Development: </b> Our services help businesses achieve their goals and develop their business.</li>
                        <li><b> Skill Enhancement: </b> Our training services help individuals and businesses develop their skills and knowledge.</li>
                        <li><b>Financial Stability:</b> Our financial management services help businesses manage their financial resources.</li>

                    </ul>
                </div>

                <br />
                <div>
                    <p class='fs-3'>Conclusion</p>
                    <p>ARV Services and Consultant is a company that provides various services to help businesses and individuals achieve their goals. Our experienced team and customer-centric approach enable us to understand our customers' needs and meet their expectations.</p>

                </div>
            </div>


            <div class='mt-3 '>
                <div class='col-11 m-auto mt-3 row align-items-end '>
                    <div class='col-xl-4 col-lg-5   p-0' style={{ height: '100%' }}>
                        <div class='col-sm-10 m-auto mt-5 position-relative h-100 '>
                            <img src={require('../image/rakesh.jpg')} data-aos="fade-in" style={{ width: '100%' }} alt="" />
                            <div class=''></div>
                        </div>
                    </div>
                    <div class='col-xl-8 col-lg-7'>
                        <div class='col-11 m-auto text-start' data-aos="fade-in" >
                            <p class='fs-4 fw-bold' >Message</p>
                            <p class='mt-2 tjustify'>At <b>ARV Services & Consultant</b>, our mission is to empower Food Business Operators with the knowledge and tools to achieve excellence in food safety, hygiene, and compliance.</p>
                            <p class='mt-2 tjustify'>From our base in Seoni to our branches across Central India, we’ve been committed to delivering customized, practical solutions that help organizations meet both national and global food safety standards. Whether it's implementing FSMS, ensuring FSSAI compliance, or providing skill-focused training, we strive to support our clients at every step.</p>
                            <p class='mt-2 tjustify'>Our experienced team is dedicated to building a safer, more reliable food industry. Together, we aim to raise the bar for food quality and consumer safety.</p>
                            <div class='text-end'>
                                <p class='fw-bold'>Warm regards,</p>
                                <p class='fs-4 fw-bold'>Rakesh Choubey</p>
                                <p class='fw-bold'>General Manager, ARV Services & Consultant</p>
                            </div>

                            <br /> <br />
                        </div>
                    </div>


                </div>
            </div>

            <div class='col-11 m-auto mt-5 row align-items-center text-start'>
                <div class='col-md-6'>

                    <p class='fs-1 fw-bold'>Our Team</p>
                    <p>Our team comprises seasoned professionals with extensive experience in food safety and consultancy. We
                        collaborate with a network of qualified trainers, consultants, and auditors dedicated to upholding the
                        highest standards in the food industry. Our experts stay abreast of the latest developments in food safety
                        regulations and best practices, ensuring our clients receive current and relevant guidance. </p>
                </div>
                <div class='col-md-6'>
                    <img src={require('../image/team.jpg')} class='rounded-4' style={{ width: '100%', objectFit: 'contain' }} alt="" />

                </div>


            </div>

            <div class='col-11 m-auto bgdmg rounded-4 row  mt-5  flex-column-reverse flex-md-row'>
                <div class='col-11 m-auto text-start'>
                    <br />
                    <p class='lmg fs-1 fw-semibold' data-aos="fade-up">
                        Our   <span style={{ color: 'gold' }}>Strength</span>
                    </p>
                    <ul class='lmg fs-5'>
                        <li class='mt-2' data-aos="fade-up"><b>Experienced Team: </b> A team with expdertise and experience that helps achieve business goals. </li>
                        <li class='mt-2' data-aos="fade-up"><b> Excellent Product or Service:</b>A high-quality product or service that meets fbos needs. </li>
                        <li class='mt-2' data-aos="fade-up"><b>Strong Brand:</b>A recognizable and trusted brand that builds fbos loyalty. </li>
                        <li class='mt-2' data-aos="fade-up"><b> Innovation:</b>The ability to innovate and adopt new ideas that drive business growth. </li>
                        <li class='mt-2' data-aos="fade-up"><b> Customer Service:</b> Excellent customer service that ensures customer satisfaction and loyalty. </li>
                        <li class='mt-2' data-aos="fade-up"><b>Financial Stability:</b>Financial stability that ensures business security and sustainability. </li>
                        <li class='mt-2' data-aos="fade-up"><b>Strong Network: </b>A strong network that opens up new opportunities and partnerships. </li>
                        <li class='mt-2' data-aos="fade-up"><b>Effective project strategies:  </b>Effective project strategies that promote the business and attract new customers. </li>

                    </ul>
                    <br /><br />
                </div>
            </div>



            <div class='col-11 row gap-md-0 gap-4 m-auto mt-5'>
                <div class='col-md-6'>
                    <div class='col-sm-11 m-auto  rounded-4 h-100' data-aos="fade-up" style={{ background: '#1A3E1A' }}>
                        <div class='col-11 m-auto text-start lmg'>
                            <br />
                            <p class='fs-1  fw-bold'>Mission</p>
                            <p class='fs-5'>Our mission is to promote food safety and quality, provide safe and hygienic food products to customers, and set standards of excellence in the food industry. We prioritize customer health and safety and strive for continuous innovation and excellence in food safety.</p>
                            <br />
                        </div>
                    </div>
                </div>

                <div class='col-md-6'>
                    <div class='col-sm-11 m-auto  rounded-4 h-100' data-aos="fade-up" style={{ background: '#430606' }}>
                        <div class='col-11 m-auto text-start lmg'>
                            <br />
                            <p class='fs-1  fw-bold'>Vision</p>
                            <p class='fs-5'>Our vision is to create a business that provides high-quality services to customers, becomes a leader in the industry through innovation and excellence, and makes a positive impact on our employees and community. </p>
                            <br />
                        </div>
                    </div>
                </div>
            </div>

            {/* <div class='col-11 row gap-md-0 gap-4 m-auto mt-5'>
                <div class='col-md-6'>
                    <div class='col-sm-11 m-auto  rounded-4 h-100' data-aos="fade-up" style={{ background: '#430606' }}>
                        <div class='col-11 m-auto text-start lmg'>
                            <br />
                            <p class='fs-1  fw-bold'>Strength</p>
                            <p class='fs-5'>The professionally qualified team designs the Food Safety Training Courses and HACCP Implementation procedures and documentation. Practical approach, professionalism, Food Industry experience and knowledge are our real resources / assets which includes former food safety enforcement officials and industry experts.</p>
                            <br />
                        </div>
                    </div>
                </div>

                <div class='col-md-6'>
                    <div class='col-sm-11 m-auto  rounded-4 h-100' data-aos="fade-up" style={{ background: '#1A3E1A' }}>
                        <div class='col-11 m-auto text-start lmg'>
                            <br />
                            <p class='fs-1  fw-bold'>Visible</p>
                            <p class='fs-5'>As a professional, training and consultancy company body at the forefront food safety, the ARV needs to be visible in all our fields of operation. We need the work we do to be noticed and recognized.</p>
                            <br />
                        </div>
                    </div>
                </div>

            </div> */}
            <div class='col-11 m-auto mt-5'>
                <p class='display-2 fw-bold'>Gallery</p>
            </div>

            <Gall gallery={gallery1} />
            {/* 
            <div class='col-10 m-auto mt-5'>
                <p class='fs-1 fw-bold' data-aos="fade-up">Our Core Values</p>

                <div class='row align-items-center justify-content-center mt-4'>
                    {
                        coreValue?.map((el, i) => {
                            return (
                                <div class='col-md-4 col-sm-6 col-11 m-auto mt-4' data-aos="fade-up">
                                    <div class='col-11 m-auto text-start'>
                                        <img src={el?.img} style={{ width: '100%' }} alt="" />
                                        <p class='fs-4 mt-2 fw-semibold'>{el?.title}</p>
                                        <p class=''>{el?.text}</p>
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>

            </div> */}

            <SubContact />
        </div >
    )
}

export default AboutUs